/* eslint max-classes-per-file: ["error", 2] */

'use strict';

define('vb/extensions/dynamic/private/types/serviceMetadataProviderDescriptor',[
  'vb/extensions/dynamic/private/types/abstractMetadataProviderDescriptor',
  'vb/extensions/dynamic/private/types/bridges/serviceMetadataProviderFactoryBridge',
],
(AbstractMetadataProviderDescriptor, ServiceMetadataProviderFactoryBridge) => {
  /**
   * @typedef {import(
   *   'vb/extensions/dynamic/private/types/bridges/metadataProviderFactoryBridge'
   * ).default} MetadataProviderFactoryBridge
   */

  /**
   * A "metadata" variable for providing the metadata provider to JET dynamic forms/tables.
   * Provides ONLY the basic shaping metadata, based on openapi3.
   *
   * Does NOT provide any dynamic layout functionality.
   */
  class ServiceMetadataProviderDescriptor extends AbstractMetadataProviderDescriptor {
    /**
     * @returns {MetadataProviderFactoryBridge}
     */
    // eslint-disable-next-line class-methods-use-this
    createFactoryBridge() {
      return new ServiceMetadataProviderFactoryBridge();
    }

    /**
     * Returns the type definition object for the ServiceMetadataProviderDescriptor.
     *
     * @returns {{ type: { endpoint: string } }} An object describing the type definition,.
     */
    // eslint-disable-next-line class-methods-use-this
    getTypeDefinition() {
      return {
        type: {
          endpoint: 'string',
        },
      };
    }
  }

  return ServiceMetadataProviderDescriptor;
});

